export const setRouteChange = (state, payload) => {
    state.routeChange = payload;
}
